import React from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const GeneralInfoIcon = ({ size = defaultSize }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M4 5C4 3.34315 5.34315 2 7 2H17C18.6569 2 20 3.34315 20 5V19C20 20.6569 18.6569 22 17 22H7C5.34315 22 4 20.6569 4 19V5ZM15 4H12V7.23381L12.7797 6.76599C13.2231 6.49997 13.7769 6.49997 14.2203 6.76599L15 7.23381V4ZM10 4H7C6.44772 4 6 4.44772 6 5V19C6 19.5523 6.44772 20 7 20H17C17.5523 20 18 19.5523 18 19V5C18 4.44772 17.5523 4 17 4V8.64676C17 9.57951 15.9824 10.1557 15.1826 9.67575L13.5 8.66619L11.8174 9.67575C11.0176 10.1556 10 9.57952 10 8.64676V4ZM8 13C8 12.4477 8.44772 12 9 12H13C13.5523 12 14 12.4477 14 13C14 13.5523 13.5523 14 13 14H9C8.44772 14 8 13.5523 8 13ZM8 17C8 16.4477 8.44772 16 9 16H15C15.5523 16 16 16.4477 16 17C16 17.5523 15.5523 18 15 18H9C8.44772 18 8 17.5523 8 17Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

GeneralInfoIcon.propTypes = {
  ...sizePropsTypes,
};

export default GeneralInfoIcon;
